"use strict";
const { CONTENT_TYPES: { RAW, COMPONENT, TEMPLATE }, } = require('../../constants');
exports.generateRawContent = ({ subject, body }) => ({
    type: RAW,
    subject,
    body,
});
exports.generateComponentContent = ({ subject, components }) => ({
    type: COMPONENT,
    subject,
    components,
});
exports.generateTemplateContent = ({ id }) => ({
    type: TEMPLATE,
    id,
});
//# sourceMappingURL=contentFactory.js.map